<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qvLo7H/tc-custom/9781630471774.jpg?1702539091772" alt="This image is the cover for the book No Bull Information"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">No Bull Information
      </h1>
      <p class="bookDescription body article font2">
        <p> "No Bull Information"---NBI---will help you to flourish in our information-dense world. You begin by sharpening your information sensors. I show you how to spot, avoid, and help to correct information absurdities. </p><p> Meet Arnbi---your guide on the road to better information. Arnbi has much advice to offer. Usually these are called ARMBisms such as: </p><p> Too bad, but "simple" is a square peg that seldom fits into the round hole that is our modern world. </p><p> Facts are necessary but they must be put into context (PUTFiC). </p><p> Lies, damn lies, and statistics---cute, but it's not that simple. </p><p> Winning World War II is a major cause of the heath care financing crisis of 2013. </p><p> In a matter of hours, you will be able to use principles explained in NBI, take better control of the bull-laden world around you, and take action to improve everything from supermarket pricing to politicians' clichés. You can begin on your way to check out in a supermarket </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Gamble
      </h2>
      
      <p class="authorDescription body article">Dr. John Gamble has been a professor for more than 30 years, most of that time at Penn State’s 4,500-student Behrend College in Erie, Pennsylvania where he is “Distinguished Professor of Political Science and International Law.” Dr. Gamble has nearly 100 published articles and books many of which endeavor to explain complex subjects to a broad audience. Gamble has won numerous awards for teaching and scholarship. The trigger for this book was hundreds of students trying to handle the explosion of information constantly striking us.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cef536f4